import { NavigationStack } from './navigation-stack';
import { PredefinedStackNames } from './predefined-stack-names';

export function getActiveStackByUrl(url: string, homeRootUrl: string, stacks: NavigationStack[]): NavigationStack | undefined {
    return stacks.find((x) => x.name !== PredefinedStackNames.Home && isStackActive(x, url, homeRootUrl, x.parameters.highlightUrlPattern));
}

function isStackActive(item: NavigationStack, currentUrl: string, homeRootUrl: string, highlightUrlPattern: string | undefined): boolean {
    if (highlightUrlPattern) {
        const regex = new RegExp(highlightUrlPattern);
        return regex.test(currentUrl);
    }

    return getKeyStackUrlPart(homeRootUrl, currentUrl) === getKeyStackUrlPart(homeRootUrl, item.rootUrl);
}

function getKeyStackUrlPart(homeRootUrl: string, url?: string): string {
    if (!url) {
        return '';
    }

    return url.replace(homeRootUrl, '').replace(/^\/+/, '').split('/')[0];
}
